import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=5a1a55a6&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=5a1a55a6&prod&lang=scss"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=5a1a55a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a55a6",
  null
  
)

export default component.exports